import React, { useState, useRef } from "react";
import "./ForgotPassword.css";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import axios from "axios";
import { security_key, BASE_URL } from "../global";
import LinearProgress from "@mui/material/LinearProgress";
import Image from "react-bootstrap/Image";
import logo from "./../assets/images/backgrounds/Provider.png";

const validationSchema = Yup.object().shape({
    provider_email: Yup.string().email("Invalid email").required("Email is required").strict(),
});

function ForgotPassword() {
    const navigate = useNavigate();

    const formRef = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const initialValues = {
        provider_email: "",
    };

    const { values, handleBlur, touched, handleChange, errors, handleSubmit, setTouched, resetForm, setValues } = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: async (formValues) => {
            toast.dismiss();
            setIsSubmitting(true);
            try {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "checkEmail",
                    // mode: "testMail",
                    ...formValues,
                });

                const output = response.data;

                // console.log("Response Data:", output);

                if (output["status"] == 1) {
                    toast.success(output["message"], {
                        autoClose: 3000,
                    });
                    sessionStorage.setItem("email", values.provider_email);
                    setTimeout(function () {
                        navigate("/Provider/ResetCode");
                    }, 3000);
                } else {
                    toast.error(output["message"], {
                        autoClose: 3000,
                    });
                }

                setIsSubmitting(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Invalid API. Please Contact EMSTYLE Team", {
                    autoClose: 1000,
                });
            }
        },
    });

    return (
        <>
            <ToastContainer position="top-center" />

            <div className="forgot_wrap">
                <div className="app app-auth-sign-in align-content-stretch d-flex flex-wrap justify-content-end" style={{ background: "#e7ebf8" }}>
                    <div className="app-auth-background provider-login"></div>
                    <div className="app-auth-container">
                        <div className="logo-dark mb-3 text-center">
                            <a role="button" style={{ display: "inline-block" }} onClick={() => navigate("/Patient")}>
                                {/* <Image src="../images/logo-dark.png" width={150} className="img-fluid d-block" /> */}
                                <Image src={logo} width={170} className="img-fluid d-block" />
                            </a>
                        </div>

                                         <div className="logo-light mb-3 text-center">
                                                    <a role="button" style={{ display: "inline-block" }} onClick={() => navigate("/Patient")}>
                                                        <Image src="../images/logo-light.png" width={150} className="img-fluid mb-3" />
                                                         <Image src={logo} width={170} className="img-fluid d-block" />
                                                    </a>
                                                       
                                                </div>

                        <div className="auth-credentials card border-0 shadow-lg p-5 m-b-xxl">
                            <Form autoComplete="off" onSubmit={handleSubmit} ref={formRef}>
                                <h4 className="text-center mb-4">Forgot Password?</h4>
                                <div className="form-group mb-3">
                                    <Form.Label>
                                        Enter your email address
                                        <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="provider_email"
                                        value={values.provider_email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={errors.provider_email && touched.provider_email ? "input-error" : ""}
                                    />
                                    {errors.provider_email && touched.provider_email && <p className="error">{errors.provider_email}</p>}
                                </div>
                                <div className="form-group text-center">
                                    <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                                        Submit
                                        {isSubmitting ? <LinearProgress /> : ""}
                                    </button>
                                </div>
                            </Form>
                        </div>
                        {/* <div className="auth-alts">
                            <a href="#" className="auth-alts-google" />
                            <a href="#" className="auth-alts-facebook" />
                            <a href="#" className="auth-alts-twitter" />
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
